import { createSlice } from "@reduxjs/toolkit";
import {
  getOtherFeeType,
  postInvoice,
  postOtherFeeType,
  getInvoice,
  AddPayment,
  getPayment,
  sendMail,
  AddPaymentBill,
  getPaymentType,
  AddPaymentType,
  getPaymentBill,
  deleteInvoice,
  getRemarkBooking,
  AddRemarkBooking,
  getBillUtility,
  editPayment,
  editInvoiceUtility,
  editInvoice,
} from "API/BillAPI";

const initialState = {
  OtherFeeType: [],
  AddInvioce: [],
  AddOtherFee: [],
  Invoice: [],
  InvoiceUtility: [],
  AddPayment: [],
  EditPayment: [],
  Payment: [],
  PaymentType: [],
  AddPaymentType: [],
  AddPaymentBill: [],
  PaymentBill: [],
  SendInvoice: [],
  DeleteInvoice: [],
  Remark: [],
  AddRemark: [],
  BillUtility: [],
  EditInvoice: [],
};

export const BillSlice = createSlice({
  name: "BillState",
  initialState,
  reducers: {
    updateGetOtherFeeType: (state, action) => {
      state.OtherFeeType = action.payload;
    },
    updateAddInvoice: (state, action) => {
      state.AddInvioce = action.payload;
    },
    updateAddOtherFee: (state, action) => {
      state.AddOtherFee = action.payload;
    },
    updateGetInvoice: (state, action) => {
      state.Invoice = action.payload;
    },
    updateAddPayment: (state, action) => {
      state.AddPayment = action.payload;
    },
    updateGetPayment: (state, action) => {
      state.Payment = action.payload;
    },
    updateSendInvoice: (state, action) => {
      state.SendInvoice = action.payload;
    },
    updateAddPaymentBill: (state, action) => {
      state.AddPaymentBill = action.payload;
    },
    updateGetPaymentType: (state, action) => {
      state.PaymentType = action.payload;
    },
    updateAddPaymentType: (state, action) => {
      state.AddPaymentType = action.payload;
    },
    updateGetPaymentBill: (state, action) => {
      state.PaymentBill = action.payload;
    },
    updateDeleteInvoice: (state, action) => {
      state.DeleteInvoice = action.payload;
    },
    updateGetRemark: (state, action) => {
      state.Remark = action.payload;
    },
    updateAddRemark: (state, action) => {
      state.AddRemark = action.payload;
    },
    updateGetBillUtility: (state, action) => {
      state.BillUtility = action.payload;
    },
    updateEditPayment: (state, action) => {
      state.EditPayment = action.payload;
    },
    updateEditInvoiceUtility: (state, action) => {
      state.InvoiceUtility = action.payload;
    },
    updateEditInvoice: (state, action) => {
      state.EditInvoice = action.payload;
    },
  },
});

export const { updateGetOtherFeeType } = BillSlice.actions;
export const getOtherFeeTypeDetail = (value) => async (dispatch) => {
  await getOtherFeeType(value).then(async (data) => {
    await dispatch(updateGetOtherFeeType(data));
  });
};

export const { updateAddInvoice } = BillSlice.actions;
export const AddInvoiceDetails = (value) => async (dispatch) => {
  try {
    const data = await postInvoice(value);
    dispatch(updateAddInvoice(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateAddOtherFee } = BillSlice.actions;
export const AddOtherFeeDetails = (value) => async (dispatch) => {
  try {
    const data = await postOtherFeeType(value);
    dispatch(updateAddOtherFee(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateGetInvoice } = BillSlice.actions;
export const getInvoiceDetail = (value) => async (dispatch) => {
  await getInvoice(value).then(async (data) => {
    await dispatch(updateGetInvoice(data));
  });
};

export const { updateAddPayment } = BillSlice.actions;
export const AddPaymentDetails = (value) => async (dispatch) => {
  try {
    const data = await AddPayment(value);
    dispatch(updateAddPayment(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateGetPayment } = BillSlice.actions;
export const getPaymentDetail = (value) => async (dispatch) => {
  await getPayment(value).then(async (data) => {
    await dispatch(updateGetPayment(data));
  });
};

export const { updateSendInvoice } = BillSlice.actions;
export const sendInvoiceDetails = (value) => async (dispatch) => {
  await sendMail(value).then(async (data) => {
    await dispatch(updateSendInvoice(data));
  });
};

export const { updateAddPaymentBill } = BillSlice.actions;
export const AddPaymentBillDetails = (value) => async (dispatch) => {
  try {
    const data = await AddPaymentBill(value);
    dispatch(updateAddPaymentBill(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateGetPaymentType } = BillSlice.actions;
export const getPaymentTypeDetails = (value) => async (dispatch) => {
  await getPaymentType(value).then(async (data) => {
    await dispatch(updateGetPaymentType(data));
  });
};

export const { updateAddPaymentType } = BillSlice.actions;
export const AddPaymentTypeDetails = (value) => async (dispatch) => {
  try {
    const data = await AddPaymentType(value);
    dispatch(updateAddPaymentType(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateGetPaymentBill } = BillSlice.actions;
export const getPaymentBillDetails = (value) => async (dispatch) => {
  await getPaymentBill(value).then(async (data) => {
    await dispatch(updateGetPaymentBill(data));
  });
};

export const { updateDeleteInvoice } = BillSlice.actions;
export const deleteInvoiceDetails = (value) => async (dispatch) => {
  try {
    const data = await deleteInvoice(value);
    dispatch(updateDeleteInvoice(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateGetRemark } = BillSlice.actions;
export const getRemarkDetails = (value) => async (dispatch) => {
  await getRemarkBooking(value).then(async (data) => {
    await dispatch(updateGetRemark(data));
  });
};

export const { updateAddRemark } = BillSlice.actions;
export const AddRemarkDetails = (value) => async (dispatch) => {
  try {
    const data = await AddRemarkBooking(value);
    dispatch(updateAddRemark(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateGetBillUtility } = BillSlice.actions;
export const getBillUtilityDetails = (value) => async (dispatch) => {
  await getBillUtility(value).then(async (data) => {
    await dispatch(updateGetBillUtility(data));
  });
};

export const { updateEditPayment } = BillSlice.actions;
export const editPaymentDetails = (value) => async (dispatch) => {
  try {
    const data = await editPayment(value);
    dispatch(updateEditPayment(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateEditInvoiceUtility } = BillSlice.actions;
export const editInvoiceUtilityDetails = (value) => async (dispatch) => {
  try {
    const data = await editInvoiceUtility(value);
    dispatch(updateEditInvoiceUtility(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateEditInvoice } = BillSlice.actions;
export const editInvoiceDetails = (value) => async (dispatch) => {
  try {
    const res = await editInvoice(value);
    dispatch(updateEditInvoice(res.data));

    return res.data;
  } catch (error) {
    console.error(error);
  }
};

export default BillSlice.reducer;
